var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.advisor)?_c('ReportBuilderView',{attrs:{"advisor":_vm.advisor}}):_c('div',[_vm._v("\n    Token auth has not finished yet\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }